export const genrateTax = [
  { id: 1, value: 0, label: '0%' },
  { id: 2, value: 0.1, label: '0.1%' },
  { id: 7, value: 5, label: '5%' },
  { id: 10, value: 12, label: '12%' },
  { id: 11, value: 18, label: '18%' },
];
